export default "__VITE_ASSET__0c9cc64d__"